export const RepairsActions = {
  GET_REPAIRS_LIST: "GET_REPAIRS_LIST",
  SET_REPAIRS_LIST: "SET_REPAIRS_LIST",

  GET_REPAIRS_DEFECTS_DETAILS_BY_ID_LIST: "GET_REPAIRS_DEFECTS_DETAILS_BY_ID_LIST",
  SET_REPAIRS_DEFECTS_DETAILS_BY_ID_LIST: "SET_REPAIRS_DEFECTS_DETAILS_BY_ID_LIST",
  SET_REPAIRS_LIST_PAGINATION: "SET_REPAIRS_LIST_PAGINATION"
  // define other action types here
};
